import useOneToOne from "@/utils/hooks/useOneToOne";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import routes from "@/config/routes.ts";
import { useEffect } from "react";
import { useBookOneToOneMutation } from "@/data/one-to-one.ts";
import Button from "@edusogno/primitives/button.js";
import { useTranslation } from "react-i18next";
import LoadingButton from "@edusogno/primitives/loading-button";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";
import PageHeading from "@/components/ui/PageHeading.tsx";
import MobileLayout from "@/components/one-to-one/MobileLayout.tsx";
import BoxAndLabel from "@/components/one-to-one/LabelAndBox.tsx";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@edusogno/primitives/avatar";
// import tutorPic2 from "@/assets/img/tutorPic1.png";
import {
  options,
  topics,
  topicsId,
  TopicsWithId,
} from "@/components/one-to-one/Constants.tsx";
import { useMe } from "@/data/user";
import { useBreakpoint } from "@/utils/hooks/useBreakpoints";

const ConfirmSecondSession = () => {
  const { date, hour, category, tutorSelected, topic } = useOneToOne();
  const categoryItem = options[Number(category)];
  const newDate = dayjs(date);

  const navigate = useNavigate();

  const { t } = useTranslation();

  const { me } = useMe();

  const breakpoint = useBreakpoint();

  const isSmallScreen = ["xs", "sm", "md", "lg"].indexOf(breakpoint) !== -1;
  useEffect(() => {
    if (!date && !hour) {
      navigate(routes.one_to_one);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, hour]);

  const { mutateAsync, isError, isLoading } = useBookOneToOneMutation();

  const handleConfirm = async () => {
    if (!me || !tutorSelected) return;
    await mutateAsync({
      // tutor_token: tutor,

      tutor_token: tutorSelected.token,
      user_token: me.item.user.token,
      data: dayjs(date).format("YYYY-MM-DD"),
      ora: hour,
      ora_fine: dayjs(dayjs(date).format("YYYY-MM-DD") + " " + hour)
        .add(1, "hour")
        .format("HH:mm"),
      titolo_argomento: options[Number(category)]?.text,
      descrizione:
        topicsId[options[Number(category)]?.key as keyof TopicsWithId][
          Number(topic)
        ].title,
      id_material: topicsId[options[Number(category)]?.key as keyof TopicsWithId][
        Number(topic)
      ].id,
    });

    if (isError) return;

    navigate("../one-to-one/second-session/details", {
      //@ts-expect-error this is expected
      relative: true as unknown,
    });
  };

  return (
    <>
      <DashboardContentLayout className="relative  pb-0 !px-0 flex flex-col h-full">
        {/*<AbsoluteBackground className={"bg-brand-background-light -z-30"} />*/}
        {!isSmallScreen && (
          <PageHeading
            title={t("one_to_one.title")}
            subtitleClassName={"!text-light"}
            subtitle={t("one_to_one.subtitle")}
            className={"until-lg:px-4 until-lg:pb-0"}
          />
        )}
        <MobileLayout
          heading={"Recap of your 1:1 class"}
          subheading={"Confirm your 1:1 class to book the event"}
        >

          <div className="w-full h-full pt-2 gap-1  max-h-[300px]  mb-auto justify-evenly flex flex-col">
            <BoxAndLabel
              label={"Day and time "}
              value={
                newDate?.format("ddd DD/MM/YYYY")?.toUpperCase() +
                "  at " +
                hour
              }
            />
            <BoxAndLabel
              label={"Tutor"}
              value={
                <div
                  className={"flex flex-row justify-center gap-4 items-center"}
                >
                  <Avatar className={"w-[31px] h-[31px]"}>
                    <AvatarImage src={tutorSelected?.image} />
                    <AvatarFallback>
                      {tutorSelected?.name?.charAt(0)}
                    </AvatarFallback>
                  </Avatar>
                  <p className={" text-sm font-bold"}>{tutorSelected?.name}</p>
                </div>
              }
            />
            <BoxAndLabel label={"Category"} value={categoryItem?.text} />
            {/* <Box label={'Topic'} value={topics[Number(data?.topic)]?.title} /> */}
            <BoxAndLabel
              label={"Topic"}
              value={
                topics[categoryItem?.key][topic as unknown as number]?.title
              }
            />
          </div>
          <div
            className={
              "flex gap-2 items-center justify-center  w-full flex-row"
            }
          >
            <Button size={"md"} color={"white"} onClick={() => navigate(-1)}>
              {/* Go back */}
              {t("btns.back")}
            </Button>
            <LoadingButton
              // eslint-disable-next-line @typescript-eslint/no-misused-promises
              onClick={() => handleConfirm()}
              loading={isLoading}
              disabled={isLoading}
              color={"green"}
              size={"md"}
              className="flex items-center justify-center gap-1"
            >
              {/* Confirm */}
              {t("btns.confirm")}
            </LoadingButton>
          </div>
        </MobileLayout>
      </DashboardContentLayout>
    </>
  );
};

export default ConfirmSecondSession;
